import React from 'react';
import { Link } from 'react-router-dom';
import { Search, Music } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card } from '@/components/ui/card';
import { 
  MobileHeader, MobileBottomNav, DesktopHeader 
} from '@/components/layout/MobileLayout';
import { mockArtists } from '@/lib/mockData';

export function UserArtistsList() {
  return (
    <div className="min-h-screen bg-background" data-testid="user-artists-list">
      {/* Mobile Header */}
      <MobileHeader />
      
      {/* Desktop Header */}
      <DesktopHeader />
      
      <main className="pt-14 lg:pt-20 pb-24 lg:pb-12">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h1 className="text-3xl font-bold text-white">Artists</h1>
              <p className="text-muted-foreground mt-1">{mockArtists.length} artists</p>
            </div>
            <div className="relative w-64">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
              <Input 
                placeholder="Search artists..." 
                className="bg-card border-border pl-10"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
            {mockArtists.map(artist => (
              <Link key={artist.id} to={`/artists/${artist.id}`}>
                <Card className="bg-card border-border p-4 text-center hover:border-primary/50 transition-all group">
                  <div className="w-24 h-24 mx-auto rounded-full overflow-hidden border-4 border-border group-hover:border-primary transition-colors mb-4">
                    <img 
                      src={artist.image} 
                      alt={artist.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="font-semibold text-white group-hover:text-primary transition-colors">{artist.name}</h3>
                  <p className="text-sm text-muted-foreground flex items-center justify-center gap-1 mt-1">
                    <Music className="w-3 h-3" />
                    {artist.instrument}
                  </p>
                  <p className="text-xs text-muted-foreground mt-2">
                    {artist.totalPerformances} performances
                  </p>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      </main>

      {/* Mobile Bottom Navigation */}
      <MobileBottomNav />
    </div>
  );
}

export default UserArtistsList;
